import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Isvg from 'react-inlinesvg';

import { PFE_ICONS } from 'constants/icons';
import { EMAIL_REGEX } from 'constants/logic';
import { bem } from 'helpers/class-name';
import { Form, Input, Button } from 'components/HookForm';
import Message from 'components/Message';

import { forgotPasswordFormMessages as messages, validationMessages } from './Auth.messages';

const { element } = bem('auth');

function ForgotPassword(props) {
  const { handleSubmit } = props;

  return (
    <div className={element('wrapper')}>
      <Isvg className={element('logo')} src={PFE_ICONS.logotype} />

      <Form onSubmit={handleSubmit}>
        <Message message={messages.title} as="h1" className={element('header')} />

        <Input
          name="email"
          type="email"
          placeholder={messages.email}
          required
          pattern={{
            value: EMAIL_REGEX,
            message: validationMessages.invalidEmail,
          }}
          className={element('input', 'mb-r')}
          autoFocus
        />

        <Message message={messages.submit} as={Button} type={Button.TYPES.SUBMIT} className={element('submit')} />
      </Form>

      <div className={element('quick-link-container')}>
        <Message message={messages.back} as={Link} to="/login" className={element('quick-link')} />
      </div>
    </div>
  );
}

ForgotPassword.propTypes = {
  handleSubmit: PropTypes.func,
};

export default ForgotPassword;
